/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Workflow, WorkflowFromJSON, WorkflowToJSON,} from './Workflow';

/**
 *
 * @export
 * @interface WorkflowPageOf
 */
export interface WorkflowPageOf {
    /**
     *
     * @type {number}
     * @memberof WorkflowPageOf
     */
    totalRecords?: number;
    /**
     *
     * @type {Array<Workflow>}
     * @memberof WorkflowPageOf
     */
    data?: Array<Workflow> | null;
}

export function WorkflowPageOfFromJSON(json: any): WorkflowPageOf {
    return WorkflowPageOfFromJSONTyped(json, false);
}

export function WorkflowPageOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowPageOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(WorkflowFromJSON)),
    };
}

export function WorkflowPageOfToJSON(value?: WorkflowPageOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'totalRecords': value.totalRecords,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(WorkflowToJSON)),
    };
}

